import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { bool, extendComponent, oneOf } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { DATE_FORMATS, getDateFormat } from '@philips-internal/oswald-ui-model/lib/formatters/date/date-utils.js';
import { Text } from '../text/text.js';
import { CurrentDatetimeAPI } from './current-datetime-api.js';
const awesomeProps = {
    api: CurrentDatetimeAPI,
    type: ComponentType.DATA_DISPLAY,
};
function CurrentDatetime(props) {
    const [currentDate, setCurrentDate] = useState(new Date());
    useEffect(() => {
        if (props.frozen) {
            return;
        }
        const interval = setInterval(() => setCurrentDate(new Date()), 1000);
        return () => {
            clearInterval(interval);
        };
    }, [props.frozen]);
    return (React.createElement(Text, { ...props.label, value: moment(currentDate).format(getDateFormat(props.format).format) }));
}
CurrentDatetime.propTypes = {
    format: oneOf(Object.keys(DATE_FORMATS)),
    frozen: bool,
    label: extendComponent('Text', ['size', 'type'], ['alignment', 'className', 'formatters', 'sensitiveData', 'value']),
};
CurrentDatetime.defaultProps = {
    format: 'medium',
};
AwesomeComponent(awesomeProps)(CurrentDatetime);
export { CurrentDatetime, };
//# sourceMappingURL=current-datetime.js.map